import Button from "@components/common/Button";
import ActivationBusinessUnitClientConfigSection from "@components/sections/activation/ActivationBusinessUnitClientConfigSection";
import {
	postConfigurationByBusinessUnitId,
	postConfigurationByClientId,
	postConfigurationByVesselId,
	putConfigurationByBusinessUnitId,
	putConfigurationByClientId,
	putConfigurationByVesselId,
} from "@services/accountMangement/accountNumbersService";
import { Modal } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { customModalTheme } from "styles/customTheme";
import ModalAlert from "./ModalAlert";

export const ModalConfigurationBUClientVessel = React.memo(
	({
		bu_client_id,
		isOpen,
		selectedRowData,
		closeModal,
		token,
		fetchConfigurations,
		typeEntity,
	}) => {
		const [showErrorModal, setShowErrorModal] = useState(false);
		const [errorMessage, setErrorMessage] = useState(false);
		const [successMessage, setSuccessMessage] = useState(false);
		const [showSuccessModal, setShowSuccessModal] = useState(false);
		const [loading, setLoading] = useState(false);
		const [formData, setFormData] = useState({
			type: null,
			account_number_id: null,
		});
		const [errors, setErrors] = useState({});

		let postConfiguration;
		let putConfiguration;

		if (typeEntity === "business_unit") {
			postConfiguration = postConfigurationByBusinessUnitId;
			putConfiguration = putConfigurationByBusinessUnitId;
		} else if (typeEntity === "clients") {
			postConfiguration = postConfigurationByClientId;
			putConfiguration = putConfigurationByClientId;
		} else if (typeEntity === "vessels") {
			postConfiguration = postConfigurationByVesselId;
			putConfiguration = putConfigurationByVesselId;
		}

		useEffect(() => {
			if (selectedRowData) {
				setFormData((prev) => ({
					...prev,
					type: selectedRowData.type || "",
					account_number_id: selectedRowData.account_number?.id || "",
					account_number: selectedRowData.account_number?.number || "",
					status: selectedRowData.status ?? 0,
					is_block_related: selectedRowData.block_product === 1 ? "yes" : "no",

					countryName: selectedRowData.account_number?.country || "",
					countryCode: selectedRowData.account_number?.country || "",
					fixed_address: selectedRowData.fixed_address || "",
					subscription: selectedRowData.vessel_subscriptions?.map((s) => s.id) || [],
					is_prorata: selectedRowData.is_prorata,
				}));
			} else {
				setFormData({
					type: null,
					account_number_id: null,
				});
			}
		}, []);

		useEffect(() => {
			if (!selectedRowData) {
				setFormData((prevFormData) => ({
					...prevFormData,
					subscription: [],
					is_block_related: "",
					//account_number_id: "",
					//account_number_name: "",
				}));
			}
		}, [formData.isPool]);

		useEffect(() => {
			if (!selectedRowData) {
				setFormData((prevFormData) => ({
					...prevFormData,
					subscription: [],
					countryName: null,
					countryCode: null,
					account_number_id: null,
					account_number_name: null,
					isPool: null,
					is_block_related: null,
				}));
			}
		}, [formData.type]);

		const validateForm = () => {
			let valid = true;
			const validationErrors = {};

			if (selectedRowData) {
				if (!formData.type) {
					valid = false;
					validationErrors.type = "Type is required.";
				}
				if (!formData.account_number_id) {
					valid = false;
					validationErrors.account_number_id = "Account Number is required.";
				}
				if (
					formData.is_prorata === null ||
					formData.is_prorata === undefined ||
					formData.is_prorata === ""
				) {
					valid = false;
					validationErrors.is_prorata = "Prorata is required.";
				}
			} else {
				if (formData.isPool === undefined || formData.isPool === "") {
					valid = false;
					validationErrors.isPool = "Type of role is required.";
				}
				if (!formData.type) {
					valid = false;
					validationErrors.type = "Type is required.";
				}

				if (formData.type === "LAND" && !formData.countryName) {
					valid = false;
					validationErrors.countryName = "Country Name is required.";
				}
				if (!formData.subscription) {
					valid = false;
					validationErrors.subscription = "Subscription is required.";
				}
				if (!formData.account_number_id) {
					valid = false;
					validationErrors.account_number_id = "Account Number is required.";
				}
				if (formData.isPool === 1 && !formData.is_block_related) {
					valid = false;
					validationErrors.is_block_related = "Related to Block is required.";
				}
				if (
					formData.is_prorata === null ||
					formData.is_prorata === undefined ||
					formData.is_prorata === ""
				) {
					valid = false;
					validationErrors.is_prorata = "Prorata is required.";
				}
			}

			setErrors(validationErrors);
			return valid;
		};
		const handleSubmit = async () => {
			if (validateForm()) {
				setLoading(true);
				try {
					let response;
					if (selectedRowData?.id) {
						response = await putConfiguration(
							selectedRowData.id,
							token,
							formData,
							typeEntity,
							Number(bu_client_id),
						);
					} else {
						response = await postConfiguration(bu_client_id, token, formData);
					}

					if (response && (response.status === 200 || response.status === 201)) {
						setFormData({
							type: "",
							account_number_id: "",
							fixed_address: "",
							status: "",
							countryName: "",
							subscription: [],
							is_block_related: "",
							is_prorata: null,
						});
						closeModal();
						setShowSuccessModal(true);
						setTimeout(() => fetchConfigurations(), 1000);
					} else if (response?.status === 422) {
						if (response.errors?.country) {
							const errorsWithCountryName = {
								...response.errors,
								countryName: response.errors.country,
							};
							delete errorsWithCountryName.country;
							setErrors(errorsWithCountryName);
						} else {
							setErrors(response.errors);
						}
						setShowErrorModal(true);
					} else {
						console.error("Failed to create/update configuration.");
						setShowErrorModal(true);
					}
				} catch (error) {
					console.error("Error during API call:", error);
				} finally {
					setLoading(false);
				}
			}
		};
		const handleClose = () => {
			setFormData({
				type: "",
				account_number_id: "",
				fixed_address: "",
				status: "",
				countryName: "",
				subscription: [],
			});
			setErrors({});
			closeModal();
		};

		return (
			<>
				<Modal show={isOpen} onClose={handleClose} size="4xl" theme={customModalTheme}>
					<Modal.Header>
						<span className="text-white">
							{selectedRowData
								? `Update Activation Config - ${selectedRowData?.reference_id}`
								: "Create Activation Config"}
						</span>
					</Modal.Header>
					<Modal.Body className="custom-scrollbar">
						<div className="space-y-6">
							<ActivationBusinessUnitClientConfigSection
								token={token}
								formData={formData}
								setFormData={setFormData}
								errors={errors}
								setErrors={setErrors}
								selectedRowData={selectedRowData}
								closeModal={closeModal}
							/>
						</div>
					</Modal.Body>
					<Modal.Footer className="">
						<Button
							text={loading ? "Loading..." : "Submit"}
							onClick={() => handleSubmit()}
							className="bg-button-bg text-white hover:bg-button-hover"
							disabled={loading} // Disable button while loading
						/>
						<Button
							text={"Cancel"}
							color="gray"
							onClick={handleClose}
							className="bg-gray-700 text-white hover:bg-gray-800"
						/>
					</Modal.Footer>
				</Modal>
				<ModalAlert
					isOpen={showErrorModal}
					type="error"
					timeout={1000}
					closeModal={() => setShowErrorModal(false)}
					message={errorMessage}
				/>

				<ModalAlert
					isOpen={showSuccessModal}
					type="success"
					timeout={1000}
					closeModal={() => setShowSuccessModal(false)}
					message={successMessage}
				/>
			</>
		);
	},
);
